import { refundMethods } from '@reveni-io/reveni-ui'

export const refundMethodsWithExtra = [refundMethods.storeCredit, refundMethods.giftCard]

export const refundMethodExtraLabels = {
  [refundMethods.storeCredit]: 'Crédito en tienda extra',
  [refundMethods.giftCard]: 'Tarjeta regalo extra',
}

export const transactionTypes = {
  instantRefund: 'instant_refund',
  refund: 'refund',
  exchange: 'exchange',
  instantExchange: 'instant_exchange',
  mixed: 'mixed',
}

export const statuses = {
  inProgress: 'in_progress',
  rejected: 'rejected',
  accepted: 'accepted',
  shipped: 'shipped',
  received: 'received',
  partiallyAccepted: 'partially_accepted',
  cancelled: 'cancelled',
  forReview: 'for_review',
  pending: 'pending',
  onHold: 'on_hold',
}

export const refundStatuses = {
  pending: 'pending',
  completed: 'completed',
}

export const paymentStatuses = {
  pending: 'pending',
  completed: 'completed',
}

export const providers = {
  prestashop: 'prestashop',
  prestashop_with_module: 'prestashop-with-module',
  shopify: 'shopify',
  woocommerce: 'woocommerce',
  magento: 'magento',
  api: 'api',
  apiPrestashop: 'api-prestashop',
  apiAmphora: 'api-amphora',
  apiAmphoraShopify: 'api-amphora-shopify',
  apiIflastmile: 'api-iflastmile',
  apiIflastmileShopify: 'api-iflastmile-shopify',
  apiIflastmileWoocommerce: 'api-iflastmile-woocommerce',
  apiReturngo: 'api-returngo',
  apiReturngoShopify: 'api-returngo-shopify',
  centra: 'centra',
  bigcommerce: 'bigcommerce',
}

export const recoveryStatuses = {
  collected: 'collected',
  pending: 'pending',
  notCollected: 'not_collected',
  notApplicable: 'not_applicable',
}

export const alertTypes = {
  missingCustomsData: 'missing_customs_data',
  wrongAddress: 'wrong_address',
  incompleteAddress: 'incomplete_address',
  labelCreationError: 'label_creation_error',
  pickupCreationError: 'pickup_creation_error',
  refundOnHold: 'refund_on_hold',
  exchangeOnHold: 'exchange_on_hold',
  exchangeOrderError: 'exchange_order_error',
  rtsParcelExported: 'rts_parcel_exported',
  rtsPaymentFailed: 'rts_payment_failed',
  rtsWrongAddress: 'rts_wrong_address',
  rtsUnknownRecipient: 'rts_unknown_recipient',
  rtsDamaged: 'rts_damaged',
  rtsNotPickUpByRecipient: 'rts_not_picked_up_by_recipient',
  rtsFeesRefusedByRecipient: 'rts_fees_refused_by_recipient',
  rtsProhibitedContent: 'rts_prohibited_content',
  rtsInTransit: 'rts_in_transit',
  rtsRefusedByRecipient: 'rts_refused_by_recipient',
  rtsDelivered: 'rts_delivered',
  negativeSentiment: 'negative_sentiment',
  timeIssue: 'time_issue',
  unexpectedItems: 'unexpected_items_pending',
}

export const transactionAlertTexts = {
  [alertTypes.missingCustomsData]: 'Error al generar etiqueta de devolución – falta información de aduanas',
  [alertTypes.wrongAddress]: 'Error al generar la etiqueta de devolución: dirección incorrecta',
  [alertTypes.incompleteAddress]: 'Error al generar la etiqueta de devolución: dirección incorrecta',
  [alertTypes.labelCreationError]: 'Error al generar la etiqueta de devolución',
  [alertTypes.pickupCreationError]: 'Error al crear la recogida',
  [alertTypes.refundOnHold]: 'Reembolso retenido: {{reason}}',
  [alertTypes.exchangeOnHold]: 'Pedido de cambio en espera: {{reason}}',
  [alertTypes.exchangeOrderError]: 'Error al crear el pedido de cambio: no hay stock disponible',
  [alertTypes.rtsParcelExported]: 'Devuelto al remitente – Reexportado desde destino',
  [alertTypes.rtsPaymentFailed]: 'Devuelto al remitente – Pago fallido',
  [alertTypes.rtsWrongAddress]: 'Devuelto al remitente – Dirección incorrecta',
  [alertTypes.rtsUnknownRecipient]: 'Devuelto al remitente – Destinatario desconocido',
  [alertTypes.rtsDamaged]: 'Devuelto al remitente – Dañado',
  [alertTypes.rtsNotPickUpByRecipient]: 'Devuelto al remitente – No recogido',
  [alertTypes.rtsFeesRefusedByRecipient]: 'Devuelto al remitente – Tasas rechazadas',
  [alertTypes.rtsProhibitedContent]: 'Devuelto al remitente – Contenido prohibido',
  [alertTypes.rtsInTransit]: 'Devuelto al remitente – En tránsito',
  [alertTypes.rtsRefusedByRecipient]: 'Devuelto al remitente – Rechazado por el destinatario',
  [alertTypes.rtsDelivered]: 'Devuelto al remitente – Entregado',
  [alertTypes.negativeSentiment]: 'Sentimiento del cliente muy negativo',
  [alertTypes.timeIssue]: 'Problema urgente: {{notes}}',
  [alertTypes.unexpectedItems]: 'Productos devueltos adicionales no asociados a este pedido',
}

export const conceptCategories = {
  fee: 'fee',
  amountToReturn: 'amount_to_return',
}

export const breakdownableConcept = 'original_amount'

export const shippingConcept = 'shipping_amount'

export const exchangeItemsConcept = 'exchange_items_refund_amount'

export const expandableConcepts = ['original_amount', 'exchange_items_refund_amount']

export const conceptAmountErrors = {
  exceeded: 'exceeded',
  invalid: 'invalid',
}
